"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrowserMainThread = exports.isBrowser = exports.isServer = exports.isWorker = void 0;
exports.isWorker = typeof WorkerGlobalScope !== 'undefined';
exports.isServer = !exports.isWorker && typeof window === 'undefined';
exports.isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
exports.isBrowserMainThread = exports.isBrowser && !exports.isWorker;
//# sourceMappingURL=flags.js.map